import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectSelf = (s: RootState) => s.cart;

export const totalNumberOfItemsInCartSelector = createSelector(
  selectSelf,
  (s) => s.items_count,
);

export const hasItemsInCartSelector = createSelector(
  totalNumberOfItemsInCartSelector,
  (s) => !!s,
);

export const reservedAtSelector = createSelector(
  selectSelf,
  (s) => new Date(s.reserved),
);

export const reservationEndTimeSelector = createSelector(
  selectSelf,
  (s) => s.reservationEndTime,
);
